import { FunctionComponent, useEffect, useState } from 'react';

import { useAppSettings, useRouteData } from '@dw/hooks';
import { Button, Snackbar, Stack } from '@mui/material';

export const AppVersionChecker: FunctionComponent = () => {

  const { appSettings } = useAppSettings();
  const { setSearchParams, cachebuster: cachebusterQueryParam } = useRouteData<{ cachebuster: string }>();

  const [updateAvailableSnackbarOpen, setUpdateAvailableSnackbarOpen] = useState(false);
  const [activeVersion, setActiveVersion] = useState('');
  const [versionToUpdateTo, setVersionToUpdateTo] = useState('');
  const [versionToSkip, setVersionToSkip] = useState('');

  const skipVersionUpdate = () => {
    setVersionToSkip(versionToUpdateTo);
    setUpdateAvailableSnackbarOpen(false);
  };

  const addNoCacheHeaders = () => {
    const noCacheEl = document.createElement('meta');
    noCacheEl.httpEquiv = 'Cache-control';
    noCacheEl.content = 'no-cache';
    noCacheEl.id = 'cachebuster';

    const cacheExpireEl = document.createElement('meta');
    cacheExpireEl.httpEquiv = 'Expires';
    cacheExpireEl.content = '-1';
    cacheExpireEl.id = 'cachebuster-expire';

    if (!document.getElementById('cachebuster')) {
      document.head.appendChild(noCacheEl);
    }

    if (!document.getElementById('cachebuster-expire')) {
      document.head.appendChild(cacheExpireEl);
    }
  }

  const hardReloadPage = () => {
    setSearchParams((current) => ({
      ...current,
      cachebuster: new Date().getTime().toString()
    }));
    addNoCacheHeaders();
    window.location.reload();
  };

  useEffect(() => {
    if (!appSettings) {
      return;
    }

    if (!activeVersion) {
      setActiveVersion(appSettings.buildVersion ?? '');

      if (cachebusterQueryParam) {
        console.debug('Adding no cache headers to page...');
        addNoCacheHeaders();
      }
    } else if (!updateAvailableSnackbarOpen) {
      if (versionToSkip !== appSettings.buildVersion && activeVersion !== appSettings.buildVersion) {
        console.debug(`New website version available: v${appSettings.buildVersion}...`);
        setVersionToUpdateTo(appSettings.buildVersion ?? '');
        setUpdateAvailableSnackbarOpen(true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appSettings]);

  return (
    <Snackbar
      message='A new version is available. Click to update'
      open={updateAvailableSnackbarOpen}
      action={(
        <Stack columnGap={1} display='flex' flexDirection='row'>
          <Button
            variant='text'
            size='small'
            color='error'
            onClick={skipVersionUpdate}
          >
            Close
          </Button>
          <Button
            variant='text'
            size='small'
            color='light'
            onClick={hardReloadPage}
          >
            Update
          </Button>
        </Stack>
      )}
    />
  );
}